/** Thousandths, so 0.1 + 0.2 does not print as 0.30000000000000004. */
export function roundOutlookQty(value: number): number {
  return Math.round((value + Number.EPSILON) * 1000) / 1000;
}

export function formatOutlookQty(value: number): string {
  return roundOutlookQty(value)
    .toFixed(3)
    .replace(/\.?0+$/, "");
}
